<template>
    <v-dialog v-model="show" hide-overlay max-width="1200" transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card class="py-0">
                        <v-toolbar class="py-0 my-0" color="yellow">
                            <v-toolbar-title class="my-0 py-0">Calibración Instrumento</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-toolbar>
                    </v-card>
                    <v-card color="yellow lighten-4" class="py-0 my-0">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="8">
                                    <h6> {{ instrumento }} </h6>
                                </v-col>
                                <v-col cols="6" sm="2" md="2">
                                    <v-text-field color="yellow darken-2" dense v-model="fecha"
                                        label="Fecha"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="2" md="2">
                                    <v-text-field color="yellow darken-2" dense v-model="codcalib"
                                        label="N° Calibración"></v-text-field>
                                </v-col>
                            </v-row>

                        </v-card-text>
                    </v-card>
                    <v-card v-if="flagtipo == 'D'" color="yellow lighten-5" class="py-0 my-0">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="2" md="2">
                                    <v-text-field color="yellow darken-2" label="Valor a Fondo de Escala" dense
                                        v-model="valorfe"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="2" md="2">
                                    <v-text-field color="yellow darken-2" label="Unidad Fondo de Escala" dense
                                        v-model="unidadfe"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-select item-color="yellow" color="yellow darken-2" dense v-model="patronD"
                                        :items="listadopatronD" label="Patrón Secundario" item-text="nombre"
                                        return-object item-value="codgral"
                                        @change="certificadocalib(patronD.codgral, 'D')"></v-select>
                                </v-col>
                                <v-col cols="6" sm="2" md="2">
                                    <h6><a v-if="flagpatronD" target="_blank"
                                            :href="'https://api.icssa.com.ar/fotosEquipos/' + certificadopatron.descripcion">Certificado</a>
                                    </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-data-table dense :headers="headersD" :items="calibdigital" locale="es-ar"
                                        height="300" fixed-header class="elevation-1" :items-per-page="20"
                                        hide-default-footer>
                                        <template v-slot:item.lectinst="{ item }">
                                            <v-text-field dense v-model="item.lectinst"></v-text-field>
                                        </template>
                                        <template v-slot:item.lectpatron="{ item }">
                                            <v-text-field dense v-model="item.lectpatron"></v-text-field>
                                        </template>
                                        <template v-slot:item.unidad="{ item }">
                                            <v-text-field dense v-model="item.unidad"></v-text-field>
                                        </template>
                                        <!-- <template v-slot:item.errorabs="{ item }">
                                            <v-text-field dense v-model="item.errorabs"></v-text-field>
                                        </template>
                                        <template v-slot:item.errorrelat="{ item }">
                                            <v-text-field dense v-model="item.errorrelat"></v-text-field>
                                        </template> -->
                                    </v-data-table>
                                </v-col>

                            </v-row>
                            <v-row dense>
                                <v-btn dense class="mx-2" dark small color="orange" @click="addRow('D')">Agregar
                                    fila</v-btn>
                            </v-row>
                        </v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="3" md="3">
                                <v-btn dense class="mx-2" dark small color="red" @click="calcularerrord()"
                                    :disabled="validbotoncald">Calcular
                                    Error</v-btn>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <h6>Cantidad: {{ cantidad }}</h6>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <h6>Error Absoluto Máximo: {{ errorabsoluto }}</h6>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <h6>Error Relativo % Máximo: {{ errorrelativo }}</h6>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card v-if="flagtipo == 'M'" color="yellow lighten-5" class="py-0 my-0">
                        <v-card-text>
                            <v-tabs background-color="#02AC66" dark show-arrows>
                                <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                                <v-tab>Interna </v-tab>
                                <v-tab> Externa </v-tab>
                                <v-tab> Profundidad </v-tab>
                                <v-tab> Otros </v-tab>
                                <v-tab-item>
                                    <v-card>
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="6" sm="6" md="6">
                                                    <v-select item-color="yellow" color="yellow darken-2" dense
                                                        v-model="patronMI" :items="listadopatronint"
                                                        label="Patrón Secundario" item-text="nombre" return-object
                                                        item-value="codgral"
                                                        @change="certificadocalib(patronMI.codgral, 'MI')"></v-select>
                                                </v-col>
                                                <v-col cols="6" sm="2" md="2">
                                                    <h6><a v-if="flagpatronMI" target="_blank"
                                                            :href="'https://api.icssa.com.ar/fotosEquipos/' + certificadopatron.descripcion">Certificado</a>
                                                    </h6>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-data-table dense :headers="headersM" :items="calibmecanicoint"
                                                        locale="es-ar" height="300" fixed-header class="elevation-1"
                                                        :items-per-page="20" hide-default-footer>

                                                        <template v-slot:item.lectpatron="{ item }">
                                                            <v-text-field dense
                                                                v-model="item.lectpatron"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.unidad="{ item }">
                                                            <v-text-field dense v-model="item.unidad"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst1="{ item }">
                                                            <v-text-field dense v-model="item.lectinst1"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst2="{ item }">
                                                            <v-text-field dense v-model="item.lectinst2"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst3="{ item }">
                                                            <v-text-field dense v-model="item.lectinst3"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst4="{ item }">
                                                            <v-text-field dense v-model="item.lectinst4"></v-text-field>
                                                        </template>
                                                        <!-- <template v-slot:item.promedio="{ item }">
                                                            <v-text-field dense v-model="item.promedio"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.error="{ item }">
                                                            <v-text-field dense v-model="item.error"></v-text-field>
                                                        </template> -->
                                                    </v-data-table>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-btn dense class="mx-2" dark small color="orange"
                                                    @click="addRow('MI')">Agregar
                                                    fila</v-btn>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="6" sm="3" md="2">
                                                    <v-btn dense class="mx-2" dark small color="red"
                                                        @click="calcularerrormint()" :disabled="validbotoncalm">Calcular
                                                        Error</v-btn>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="1">
                                                    <h6>Cantidad: {{ cantidadint }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Máximo: {{ errormaximoint }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Mínimo: {{ errorminimoint }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Promedio: {{ errorpromedioint }}</h6>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card>
                                        <v-card-text>
                                            <v-row dense>

                                                <v-col cols="6" sm="6" md="6">
                                                    <v-select item-color="yellow" color="yellow darken-2" dense
                                                        v-model="patronME" :items="listadopatronext"
                                                        label="Patrón Secundario" item-text="nombre" return-object
                                                        item-value="codgral"
                                                        @change="certificadocalib(patronME.codgral, 'ME')"></v-select>
                                                </v-col>
                                                <v-col cols="6" sm="2" md="2">
                                                    <h6><a v-if="flagpatronME" target="_blank"
                                                            :href="'https://api.icssa.com.ar/fotosEquipos/' + certificadopatron.descripcion">Certificado</a>
                                                    </h6>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-data-table dense :headers="headersM" :items="calibmecanicoext"
                                                        locale="es-ar" height="300" fixed-header class="elevation-1"
                                                        :items-per-page="20" hide-default-footer>

                                                        <template v-slot:item.lectpatron="{ item }">
                                                            <v-text-field dense
                                                                v-model="item.lectpatron"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.unidad="{ item }">
                                                            <v-text-field dense v-model="item.unidad"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst1="{ item }">
                                                            <v-text-field dense v-model="item.lectinst1"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst2="{ item }">
                                                            <v-text-field dense v-model="item.lectinst2"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst3="{ item }">
                                                            <v-text-field dense v-model="item.lectinst3"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst4="{ item }">
                                                            <v-text-field dense v-model="item.lectinst4"></v-text-field>
                                                        </template>
                                                        <!-- <template v-slot:item.promedio="{ item }">
                                                            <v-text-field dense v-model="item.promedio"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.error="{ item }">
                                                            <v-text-field dense v-model="item.error"></v-text-field>
                                                        </template> -->
                                                    </v-data-table>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-btn dense class="mx-2" dark small color="orange"
                                                    @click="addRow('ME')">Agregar
                                                    fila</v-btn>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="6" sm="3" md="2">
                                                    <v-btn dense class="mx-2" dark small color="red"
                                                        @click="calcularerrormext()" :disabled="validbotoncalm">Calcular
                                                        Error</v-btn>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="1">
                                                    <h6>Cantidad: {{ cantidadext }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Máximo: {{ errormaximoext }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Mínimo: {{ errorminimoext }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Promedio: {{ errorpromedioext }}</h6>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card>
                                        <v-card-text>
                                            <v-row dense>

                                                <v-col cols="6" sm="6" md="6">
                                                    <v-select item-color="yellow" color="yellow darken-2" dense
                                                        v-model="patronMP" :items="listadopatronprof"
                                                        label="Patrón Secundario" item-text="nombre" return-object
                                                        item-value="codgral"
                                                        @change="certificadocalib(patronMP.codgral, 'MP')"></v-select>
                                                </v-col>
                                                <v-col cols="6" sm="2" md="2">
                                                    <h6><a v-if="flagpatronMP" target="_blank"
                                                            :href="'https://api.icssa.com.ar/fotosEquipos/' + certificadopatron.descripcion">Certificado</a>
                                                    </h6>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-data-table dense :headers="headersM" :items="calibmecanicoprof"
                                                        locale="es-ar" height="300" fixed-header class="elevation-1"
                                                        :items-per-page="20" hide-default-footer>

                                                        <template v-slot:item.lectpatron="{ item }">
                                                            <v-text-field dense
                                                                v-model="item.lectpatron"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.unidad="{ item }">
                                                            <v-text-field dense v-model="item.unidad"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst1="{ item }">
                                                            <v-text-field dense v-model="item.lectinst1"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst2="{ item }">
                                                            <v-text-field dense v-model="item.lectinst2"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst3="{ item }">
                                                            <v-text-field dense v-model="item.lectinst3"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst4="{ item }">
                                                            <v-text-field dense v-model="item.lectinst4"></v-text-field>
                                                        </template>
                                                        <!-- <template v-slot:item.promedio="{ item }">
                                                            <v-text-field dense v-model="item.promedio"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.error="{ item }">
                                                            <v-text-field dense v-model="item.error"></v-text-field>
                                                        </template> -->
                                                    </v-data-table>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-btn dense class="mx-2" dark small color="orange"
                                                    @click="addRow('MP')">Agregar
                                                    fila</v-btn>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="6" sm="3" md="2">
                                                    <v-btn dense class="mx-2" dark small color="red"
                                                        @click="calcularerrormprof()"
                                                        :disabled="validbotoncalm">Calcular
                                                        Error</v-btn>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="1">
                                                    <h6>Cantidad: {{ cantidadprof }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Máximo: {{ errormaximoprof }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Mínimo: {{ errorminimoprof }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Promedio: {{ errorpromedioprof }}</h6>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card>
                                        <v-card-text>
                                            <v-row dense>

                                                <v-col cols="6" sm="6" md="6">
                                                    <v-select item-color="yellow" color="yellow darken-2" dense
                                                        v-model="patronMO" :items="listadopatronotro"
                                                        label="Patrón Secundario" item-text="nombre" return-object
                                                        item-value="codgral"
                                                        @change="certificadocalib(patronMO.codgral, 'MO')"></v-select>
                                                </v-col>
                                                <v-col cols="6" sm="2" md="2">
                                                    <h6><a v-if="flagpatronMO" target="_blank"
                                                            :href="'https://api.icssa.com.ar/fotosEquipos/' + certificadopatron.descripcion">Certificado</a>
                                                    </h6>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-data-table dense :headers="headersM" :items="calibmecanicootro"
                                                        locale="es-ar" height="300" fixed-header class="elevation-1"
                                                        :items-per-page="20" hide-default-footer>

                                                        <template v-slot:item.lectpatron="{ item }">
                                                            <v-text-field dense
                                                                v-model="item.lectpatron"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.unidad="{ item }">
                                                            <v-text-field dense v-model="item.unidad"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst1="{ item }">
                                                            <v-text-field dense v-model="item.lectinst1"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst2="{ item }">
                                                            <v-text-field dense v-model="item.lectinst2"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst3="{ item }">
                                                            <v-text-field dense v-model="item.lectinst3"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.lectinst4="{ item }">
                                                            <v-text-field dense v-model="item.lectinst4"></v-text-field>
                                                        </template>
                                                        <!-- <template v-slot:item.promedio="{ item }">
                                                            <v-text-field dense v-model="item.promedio"></v-text-field>
                                                        </template>
                                                        <template v-slot:item.error="{ item }">
                                                            <v-text-field dense v-model="item.error"></v-text-field>
                                                        </template> -->
                                                    </v-data-table>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-btn dense class="mx-2" dark small color="orange"
                                                    @click="addRow('MO')">Agregar
                                                    fila</v-btn>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="6" sm="3" md="2">
                                                    <v-btn dense class="mx-2" dark small color="red"
                                                        @click="calcularerrormotro()"
                                                        :disabled="validbotoncalm">Calcular
                                                        Error</v-btn>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="1">
                                                    <h6>Cantidad: {{ cantidadotro }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Máximo: {{ errormaximootro }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Mínimo: {{ errorminimootro }}</h6>
                                                </v-col>
                                                <v-col cols="6" sm="3" md="3">
                                                    <h6>Error Promedio: {{ errorpromediootro }}</h6>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>

                            </v-tabs>

                        </v-card-text>

                    </v-card>
                    <v-card v-if="flagtipo == 'A'" color="yellow lighten-5" class="py-0 my-0">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="6">
                                    <v-select item-color="yellow" color="yellow darken-2" dense v-model="patronA"
                                        :items="listadopatronA" label="Patrón Secundario" item-text="nombre"
                                        return-object item-value="codgral"
                                        @change="certificadocalib(patronA.codgral, 'A')"></v-select>
                                </v-col>
                                <v-col cols="6" sm="2" md="2">
                                    <h6><a v-if="flagpatronA" target="_blank"
                                            :href="'https://api.icssa.com.ar/fotosEquipos/' + certificadopatron.descripcion">Certificado</a>
                                    </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="3" md="2">
                                    <v-text-field color="yellow darken-2" label="Lectura Instrumento" dense
                                        v-model="lecturainstrumento"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="3" md="2">
                                    <v-text-field color="yellow darken-2" label="Unidad" dense
                                        v-model="unidadinstrumento"></v-text-field>
                                </v-col>

                                <v-col cols="8" sm="6" md="2">
                                    <v-data-table dense :headers="headersA" :items="calibanalogico" locale="es-ar"
                                        height="300" fixed-header class="elevation-1" :items-per-page="20"
                                        hide-default-footer>
                                        <template v-slot:item.lectpatron="{ item }">
                                            <v-text-field dense v-model="item.lectpatron"></v-text-field>
                                        </template>

                                    </v-data-table>
                                </v-col>

                            </v-row>
                            <v-row dense>
                                <v-btn dense class="mx-2" dark small color="orange" @click="addRow('A')">Agregar
                                    fila</v-btn>
                            </v-row>
                        </v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="3" md="2">
                                <v-btn dense class="mx-2" dark small color="red" @click="calcularerrora()"
                                    :disabled="validbotoncala">Calcular
                                    Error</v-btn>
                            </v-col>
                            <v-col cols="6" sm="3" md="2">
                                <h6>Cantidad: {{ cantidadA }}</h6>
                            </v-col>
                            <v-col cols="6" sm="3" md="2">
                                <h6>Promedio: {{ promedioA }}</h6>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <h6>Error Absoluto Máximo: {{ errorabsolutoA }}</h6>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <h6>Error Relativo % Máximo: {{ errorrelativoA }}</h6>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card color="green lighten-4" class="py-0 my-0">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-textarea color="green darken-2" auto-grow rows="2" label="Observaciones" dense
                                        v-model="observ"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card color="yellow lighten-4" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}

.v-input--selection-controls {
    label {
        margin: 0 !important;
    }
}
</style>

<style scoped>
.class label {
    margin-bottom: 0 !important;
}

.multi-line {
    white-space: pre-line;
}
</style>

<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        fecha: moment().format("DD/MM/YYYY"),
        equipo: "",
        listadoequipo: [],
        frecuencia: "",
        fechaproxcalib: "",
        fechaultcalib: "",
        observ: "",
        flaginst: false,
        flagpatronA: false,
        flagpatronD: false,
        flagpatronMI: false,
        flagpatronME: false,
        flagpatronMP: false,
        flagpatronMO: false,
        cantidad: "",
        errorabsoluto: "",
        errorrelativo: "",
        lecturainstrumento: "",
        unidadinstrumento: "",
        certificadopatron: [],
        patronD: "",
        patronA: "",
        patronME: "",
        patronMI: "",
        patronMP: "",
        patronMO: "",
        cantidadint: "",
        cantidadext: "",
        cantidadprof: "",
        cantidadotro: "",
        cantidadA: "",
        promedioA: "",
        errorabsolutoA: "",
        errorrelativoA: "",
        errormaximoint: "",
        errormaximoext: "",
        errormaximoprof: "",
        errormaximootro: "",
        errorminimoint: "",
        errorminimoext: "",
        errorminimoprof: "",
        errorminimootro: "",
        errorpromedioint: "",
        errorpromedioext: "",
        errorpromedioprof: "",
        errorpromediootro: "",
        listadopatronA: [],
        listadopatronD: [],
        listadopatronint: [],
        listadopatronext: [],
        listadopatronprof: [],
        listadopatronotro: [],
        valorfe: "",
        unidadfe: "",
        ajuste: "",
        calib: [],
        calibd: [],
        calibint: [],
        calibext: [],
        calibprof: [],
        calibotro: [],
        headersI: [
            { text: "Código", value: "codinstrumento", sortable: false },
            { text: "Instrumento", value: "instrumento", sortable: false },
            { text: "Tipo", value: "tipo", sortable: false },
            { text: "Calibración Cargada", value: "estado", sortable: false },
            { text: "Acciones", value: "actions", sortable: false }
        ],
        headersA: [
            { text: "Lectura Patrón", value: "lectpatron", width: "20%", sortable: false },
        ],
        calibanalogico: [
            { lectpatron: '' },
            { lectpatron: '' },
            { lectpatron: '' },
            { lectpatron: '' },
            { lectpatron: '' }
        ],
        headersD: [
            { text: "Lectura Instrumento", value: "lectinst", width: "20%", sortable: false },
            { text: "Lectura Patrón", value: "lectpatron", width: "20%", sortable: false },
            { text: "Unidad Medida", value: "unidad", width: "10%", sortable: false },
            { text: "Error Absoluto", value: "errorabs", width: "20%", sortable: false },
            { text: "Error Relativo", value: "errorrelat", width: "20%", sortable: false },
        ],
        calibdigital: [
            { lectinst: '', lectpatron: '', unidad: '', errorabs: '', errorrelat: '' },
            { lectinst: '', lectpatron: '', unidad: '', errorabs: '', errorrelat: '' },
            { lectinst: '', lectpatron: '', unidad: '', errorabs: '', errorrelat: '' },
            { lectinst: '', lectpatron: '', unidad: '', errorabs: '', errorrelat: '' },
        ],
        headersM: [
            { text: "Valor Patrón", value: "lectpatron", width: "10%", sortable: false },
            { text: "Unidad Medida", value: "unidad", width: "10%", sortable: false },
            { text: "Lectura Instrumento 1", value: "lectinst1", width: "10%", sortable: false },
            { text: "Lectura Instrumento 2", value: "lectinst2", width: "10%", sortable: false },
            { text: "Lectura Instrumento 3", value: "lectinst3", width: "10%", sortable: false },
            { text: "Lectura Instrumento 4", value: "lectinst4", width: "10%", sortable: false },
            { text: "Promedio", value: "promedio", width: "15%", sortable: false },
            { text: "Error", value: "error", width: "15%", sortable: false },
        ],
        calibmecanicoint: [
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
        ],
        calibmecanicoext: [
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
        ],
        calibmecanicoprof: [
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
        ],
        calibmecanicootro: [
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
        ],
        estado: "P",
        estados: [
            { nombre: 'Pendiente', valor: 'P' },
            { nombre: 'Cerrado', valor: 'C' },
        ],
        validbotoncald: true,
        validbotoncalm: false,
        validbotoncala: true,
        selectedIndex: '',
        valid: false,
        validsubir: false,
        deshabilitar: false,
        lazy: false,
        selectedFiles: "",
        progressInfos: [],
        archivo: [],
        rulesarchivos: [
            (value) =>
                !value || value.size < 3000000 || "Las fotos deben pesar 3MB o menos",
        ],
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        selectedFiles: null,
        progressInfos: [],
        message: "",
        titulo: "",
        titulofoto: "",
        fileInfos: [],
        archivo: null,
    }),
    watch: {
        titulo(val) {
            if (this.titulo.length > 3 && this.tipo != null && this.tipo != "") {
                this.validsubir = true;
            } else {
                this.validsubir = false;
            }
        },

        valorfe(val) {
            if (this.valorfe != null && this.valorfe != "") {
                this.validbotoncald = false;
                this.deshabilitar = false;
            } else {
                this.validbotoncald = true;
            }
        },
        lecturainstrumento(val) {
            if (this.lecturainstrumento != null && this.lecturainstrumento != "") {
                this.validbotoncala = false;
                this.deshabilitar = false;
            } else {
                this.validbotoncala = true;
            }
        }
    },
    computed: {
        show: {
            get() {
                if (this.visible) {
                    this.cargarEquipo();
                    this.deshabilitar = false;
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    props: ["visible", "codgral", "codcalib", "flagtipo", "instrumento", "codinstrumento"],
    methods: {
        addRow(flag) {
            if (flag == "M") {
                this.mantenimiento.push({ tarea: "", repuesto: "", frecuencia: "", unidad: "", alerta: "", observ: "" },)
            }
            if (flag == "D") {
                this.calibdigital.push({ lectinst: '', umlectinst: '', lectpatron: '', umlectpatron: '', errorabs: '', errorrelat: '' },)
            }
            if (flag == "MI") {
                this.calibmecanicoint.push({ lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },)
            }
            if (flag == "ME") {
                this.calibmecanicoext.push({ lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },)
            }
            if (flag == "MP") {
                this.calibmecanicoprof.push({ lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },)
            }
            if (flag == "MO") {
                this.calibmecanicootro.push({ lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },)
            }
            if (flag == "A") {
                this.calibanalogico.push({ lectpatron: '' },)
            }
        },

        cargarCalibracion() {
            let self = this;
            if (this.flagtipo == "A") {
                axios
                    .get("/SSGG/CargarCalibana?", {
                        params: {
                            codgral: self.codgral,
                            codcalib: self.codcalib,
                            codinstrumento: self.codinstrumento,
                        },
                    })
                    .then((response) => {
                        self.lecturainstrumento = response.data.lecturainstrumento;
                        self.unidadinstrumento = response.data.unidad;
                        self.patronA = response.data.patron;
                        self.cantidadA = response.data.cantidad;
                        self.promedioA = response.data.promedio;
                        self.errorabsolutoA = response.data.errorabs;
                        self.errorrelativoA = response.data.errorrel;
                        self.fecha = response.data.fecha;
                        self.observ = response.data.observ;
                        response.data.detaana.forEach(element => {
                            this.calibanalogico.unshift({
                                lectpatron: element.lectpatron,
                            });
                        });
                    })
                    .catch((error) => {
                        self.lecturainstrumento = "";
                        self.unidadinstrumento = "";
                        self.patronA = "";
                        self.cantidadA = "";
                        self.promedioA = "";
                        self.errorabsolutoA = "";
                        self.errorrelativoA = "";
                        self.calibanalogico = [];
                        console.log("ERROR " + error);
                    });
            };
            if (this.flagtipo == "D") {
                axios
                    .get("/SSGG/CargarCalibdig?", {
                        params: {
                            codgral: self.codgral,
                            codcalib: self.codcalib,
                            codinstrumento: self.codinstrumento,
                        },
                    })
                    .then((response) => {

                        self.valorfe = response.data.valorfe;
                        self.unidadfe = response.data.unidadfe;
                        self.patronD = response.data.patron;
                        self.cantidad = response.data.cantidad;
                        self.errorabsoluto = response.data.errorabs;
                        self.errorrelativo = response.data.errorrel;
                        self.fecha = response.data.fecha;
                        self.observ = response.data.observ;
                        response.data.detadig.forEach(element => {
                            this.calibdigital.unshift({
                                lectinst: element.lectinstr,
                                lectpatron: element.lectpatron,
                                unidad: element.unidad,
                                errorabs: element.errorabs,
                                errorrelat: element.errorrel,
                            });
                        });
                    })
                    .catch((error) => {
                        self.valorfe = "";
                        self.unidadfe = "";
                        self.patron = "";
                        self.cantidad = "";
                        self.errorabsoluto = "";
                        self.errorrelativo = "";
                        self.calibdigital = [];
                        console.log("ERROR " + error);
                    });
            };
            if (this.flagtipo == "M") {
                axios
                    .get("/SSGG/CargarCalibmec?", {
                        params: {
                            codgral: self.codgral,
                            codcalib: self.codcalib,
                            codinstrumento: self.codinstrumento,
                        },
                    })
                    .then((response) => {
                        response.data.forEach(element => {
                            if (element.tipo == "I") {
                                console.log("TIPO I")
                                self.patronMI = element.patron;
                                self.cantidadint = element.cantidad;
                                self.errormaximoint = element.errormax;
                                self.errorminimoint = element.errormin;
                                self.errorpromedioint = element.errorprom;
                                self.fecha = element.fecha;
                                self.observ = element.observ;
                                element.detamec.forEach(elemento => {
                                    this.calibmecanicoint.unshift({
                                        lectinst1: elemento.lectinst1,
                                        lectinst2: elemento.lectinst2,
                                        lectinst3: elemento.lectinst3,
                                        lectinst4: elemento.lectinst4,
                                        lectpatron: elemento.lectpatron,
                                        unidad: elemento.unidad,
                                        promedio: elemento.promedio,
                                        error: elemento.error,
                                    });

                                });
                            };
                            if (element.tipo == "E") {
                                self.patronME = element.patron;
                                self.cantidadext = element.cantidad;
                                self.errormaximoext = element.errormax;
                                self.errorminimoext = element.errormin;
                                self.errorpromedioext = element.errorprom;
                                self.fecha = element.fecha;
                                self.observ = element.observ;
                                element.detamec.forEach(elemento => {
                                    this.calibmecanicoext.unshift({
                                        lectinst1: elemento.lectinst1,
                                        lectinst2: elemento.lectinst2,
                                        lectinst3: elemento.lectinst3,
                                        lectinst4: elemento.lectinst4,
                                        lectpatron: elemento.lectpatron,
                                        unidad: elemento.unidad,
                                        promedio: elemento.promedio,
                                        error: elemento.error,
                                    });

                                });
                            };
                            if (element.tipo == "P") {
                                self.patronMP = element.patron;
                                self.cantidadprof = element.cantidad;
                                self.errormaximoprof = element.errormax;
                                self.errorminimoprof = element.errormin;
                                self.errorpromedioprof = element.errorprom;
                                self.fecha = element.fecha;
                                self.observ = element.observ;
                                element.detamec.forEach(elemento => {
                                    this.calibmecanicoprof.unshift({
                                        lectinst1: elemento.lectinst1,
                                        lectinst2: elemento.lectinst2,
                                        lectinst3: elemento.lectinst3,
                                        lectinst4: elemento.lectinst4,
                                        lectpatron: elemento.lectpatron,
                                        unidad: elemento.unidad,
                                        promedio: elemento.promedio,
                                        error: elemento.error,
                                    });

                                });
                            };
                            if (element.tipo == "O") {
                                self.patronMO = element.patron;
                                self.cantidadotro = element.cantidad;
                                self.errormaximootro = element.errormax;
                                self.errorminimootro = element.errormin;
                                self.errorpromediootro = element.errorprom;
                                self.fecha = element.fecha;
                                self.observ = element.observ;
                                element.detamec.forEach(elemento => {
                                    this.calibmecanicootro.unshift({
                                        lectinst1: elemento.lectinst1,
                                        lectinst2: elemento.lectinst2,
                                        lectinst3: elemento.lectinst3,
                                        lectinst4: elemento.lectinst4,
                                        lectpatron: elemento.lectpatron,
                                        unidad: elemento.unidad,
                                        promedio: elemento.promedio,
                                        error: elemento.error,
                                    });

                                });
                            };
                        });
                    })
                    .catch((error) => {
                        console.log("ERROR " + error);
                    });
            };

        },
        cargarEquipo() {
            let self = this;
            axios
                .get("/SSGG/CargarEquipos?", {
                    params: {
                    },
                })
                .then((response) => {
                    //  self.listadoequipo = response.data;
                    response.data.forEach(element => {
                        if (element.clasificacion == "P") {
                            self.listadopatronD.push(element);
                            self.listadopatronA.push(element);
                            self.listadopatronint.push(element);
                            self.listadopatronext.push(element);
                            self.listadopatronprof.push(element);
                            self.listadopatronotro.push(element);
                        }
                    });
                })
                .catch((error) => {
                    self.listadoequipo = "";
                    console.log(error);
                });
            this.cargarCalibracion();
        },

        // completarcalib() {
        //     let self = this;
        //     self.listadoinstrumento = []
        //     self.flaginst = false
        //     self.codcalib = self.equipo.ultcodcalib
        //     self.frecuencia = self.equipo.frecuencia
        //     self.fechaultcalib = self.equipo.fechaultcalib
        //     self.fechaproxcalib = moment(self.fecha, "DD/MM/YYYY").add(self.equipo.frecuencia, 'months').locale('es').calendar()

        //     axios
        //         .get("/SSGG/CargarInstrumentos?", {
        //             params: {
        //                 codgral: self.equipo.codgral,
        //             },
        //         })
        //         .then((response) => {
        //             self.listadoinstrumento = response.data;
        //             if (self.listadoinstrumento.length > 0) {
        //                 self.flaginst = true
        //             }
        //             else {
        //                 self.flaginst = false
        //             }
        //         })
        //         .catch((error) => {
        //             self.listadoinstrumento = "";
        //             console.log(error);
        //         });
        // },

        certificadocalib(codpatron, flag) {
            let self = this;
            console.log("patron " + codpatron)
            console.log("flag " + flag)
            self.certificadopatron = []
            axios
                .get("/SSGG/CertificadoPatron?", {
                    params: {
                        codgral: codpatron,
                    },
                })
                .then((response) => {
                    self.certificadopatron = response.data;
                    console.log("long " + self.certificadopatron)
                    if (self.certificadopatron.descripcion != "" && self.certificadopatron.descripcion != null) {
                        if (flag == "D") {
                            self.flagpatronD = true
                        }
                        if (flag == "A") {
                            self.flagpatronA = true
                        }
                        if (flag == "MI") {
                            self.flagpatronMI = true
                        }
                        if (flag == "ME") {
                            self.flagpatronME = true
                        }
                        if (flag == "MP") {
                            self.flagpatronMP = true
                        }
                        if (flag == "MO") {
                            self.flagpatronMO = true
                        }
                    }
                    else {
                        self.flagpatron = false
                    }

                })
                .catch((error) => {
                    self.certificadopatron = "";
                    console.log(error);
                });
        },

        calcularerrord() {
            var totalerrorabs = 0
            var totalerrorrelat = 0
            var maxerrorabs = 0
            var maxerrorrelat = 0
            var cantidad = 0
            if (this.calibdigital.length > 0) {
                this.calibdigital.forEach(element => {
                    if (element.lectinst != '' && element.lectinst != '') {
                        cantidad = cantidad + 1
                        totalerrorabs = parseFloat(element.lectinst.toString().replace(',', '.')) - parseFloat(element.lectpatron.toString().replace(',', '.'))
                        element.errorabs = totalerrorabs.toFixed(5).toString().replace('.', ',');
                        totalerrorrelat = (parseFloat(element.lectinst.toString().replace(',', '.')) - parseFloat(element.lectpatron.toString().replace(',', '.'))) / this.valorfe * 100
                        element.errorrelat = totalerrorrelat.toFixed(5).toString().replace('.', ',');

                        if (cantidad == 1) {
                            maxerrorabs = Math.abs(totalerrorabs);
                            maxerrorrelat = Math.abs(totalerrorrelat);
                        }
                        else {
                            if (Math.abs(totalerrorabs) > Math.abs(maxerrorabs)) {
                                maxerrorabs = Math.abs(totalerrorabs)
                            }
                            if (Math.abs(totalerrorrelat) > Math.abs(maxerrorrelat)) {
                                maxerrorrelat = Math.abs(totalerrorrelat)
                            }
                        }
                    }
                })
            }
            this.cantidad = cantidad
            this.errorabsoluto = maxerrorabs.toFixed(5).toString().replace('.', ',')
            this.errorrelativo = maxerrorrelat.toFixed(5).toString().replace('.', ',')
        },
        calcularerrora() {
            var total = 0
            var cantidad = 0
            var promedio = 0
            var errorabs = 0
            var errorporc = 0
            if (this.calibanalogico.length > 0) {
                this.calibanalogico.forEach(element => {
                    if (element.lectpatron != '') {
                        cantidad = cantidad + 1
                        total = total + parseFloat(element.lectpatron.toString().replace(',', '.'))
                    }
                })
                promedio = total / cantidad
                errorabs = this.lecturainstrumento - promedio
                errorporc = (errorabs / promedio) * 100
                this.cantidadA = cantidad
                this.promedioA = Math.abs(promedio.toFixed(5)).toString().replace('.', ',')
                this.errorabsolutoA = Math.abs(errorabs.toFixed(5)).toString().replace('.', ',')
                this.errorrelativoA = Math.abs(errorporc.toFixed(5)).toString().replace('.', ',')
            }
        },

        calcularerrormint() {
            var totalpromedio = 0
            var totalerror = 0
            var maxpromedio = 0
            var maxerror = 0
            var minerror = 0
            var cantidad = 0
            var promerror = 0

            if (this.calibmecanicoint.length > 0) {
                this.calibmecanicoint.forEach(element => {
                    if (element.lectpatron != '' && element.lectpatron != 0) {
                        var n = 0
                        var lectura = 0
                        cantidad = cantidad + 1
                        if (element.lectinst1 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst1.toString().replace(',', '.'))
                        }
                        if (element.lectinst2 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst2.toString().replace(',', '.'))
                        }
                        if (element.lectinst3 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst3.toString().replace(',', '.'))
                        }
                        if (element.lectinst4 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst4.toString().replace(',', '.'))
                        }
                        if (n > 0 && lectura > 0) {
                            totalpromedio = lectura / n
                        }
                        totalerror = totalpromedio - parseFloat(element.lectpatron.toString().replace(',', '.'));
                        element.promedio = totalpromedio.toFixed(5).toString().replace('.', ',');
                        element.error = totalerror.toFixed(5).toString().replace('.', ',');
                        promerror = promerror + totalerror

                        if (cantidad == 1) {
                            minerror = Math.abs(totalerror);
                            maxerror = Math.abs(totalerror);
                        }
                        else {
                            if (Math.abs(totalerror) > Math.abs(maxerror)) {
                                maxerror = Math.abs(totalerror)
                            }
                            if (Math.abs(totalerror) < Math.abs(minerror)) {
                                minerror = Math.abs(totalerror)
                            }
                        }
                    }
                })
            }
            this.cantidadint = cantidad
            this.errormaximoint = maxerror.toFixed(5).toString().replace('.', ',')
            this.errorminimoint = minerror.toFixed(5).toString().replace('.', ',')
            this.errorpromedioint = (promerror / cantidad).toFixed(5).toString().replace('.', ',')
        },

        calcularerrormext() {
            var totalpromedio = 0
            var totalerror = 0
            var maxpromedio = 0
            var maxerror = 0
            var minerror = 0
            var cantidad = 0
            var promerror = 0

            if (this.calibmecanicoext.length > 0) {
                this.calibmecanicoext.forEach(element => {
                    if (element.lectpatron != '' && element.lectpatron != 0) {
                        var n = 0
                        var lectura = 0
                        cantidad = cantidad + 1
                        if (element.lectinst1 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst1.toString().replace(',', '.'))
                        }
                        if (element.lectinst2 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst2.toString().replace(',', '.'))
                        }
                        if (element.lectinst3 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst3.toString().replace(',', '.'))
                        }
                        if (element.lectinst4 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst4.toString().replace(',', '.'))
                        }
                        if (n > 0 && lectura > 0) {
                            totalpromedio = lectura / n
                        }
                        totalerror = totalpromedio - parseFloat(element.lectpatron.toString().replace(',', '.'));
                        element.promedio = totalpromedio.toFixed(5).toString().replace('.', ',');
                        element.error = totalerror.toFixed(5).toString().replace('.', ',');
                        promerror = promerror + totalerror

                        if (cantidad == 1) {
                            minerror = Math.abs(totalerror);
                            maxerror = Math.abs(totalerror);
                        }
                        else {
                            if (Math.abs(totalerror) > Math.abs(maxerror)) {
                                maxerror = Math.abs(totalerror)
                            }
                            if (Math.abs(totalerror) < Math.abs(minerror)) {
                                minerror = Math.abs(totalerror)
                            }
                        }
                    }
                })
            }
            this.cantidadext = cantidad
            this.errormaximoext = maxerror.toFixed(5).toString().replace('.', ',')
            this.errorminimoext = minerror.toFixed(5).toString().replace('.', ',')
            this.errorpromedioext = (promerror / cantidad).toFixed(5).toString().replace('.', ',')
        },

        calcularerrormprof() {
            var totalpromedio = 0
            var totalerror = 0
            var maxpromedio = 0
            var maxerror = 0
            var minerror = 0
            var cantidad = 0
            var promerror = 0

            if (this.calibmecanicoprof.length > 0) {
                this.calibmecanicoprof.forEach(element => {
                    if (element.lectpatron != '' && element.lectpatron != 0) {
                        var n = 0
                        var lectura = 0
                        cantidad = cantidad + 1
                        if (element.lectinst1 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst1.toString().replace(',', '.'))
                        }
                        if (element.lectinst2 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst2.toString().replace(',', '.'))
                        }
                        if (element.lectinst3 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst3.toString().replace(',', '.'))
                        }
                        if (element.lectinst4 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst4.toString().replace(',', '.'))
                        }
                        if (n > 0 && lectura > 0) {
                            totalpromedio = lectura / n
                        }
                        totalerror = totalpromedio - parseFloat(element.lectpatron.toString().replace(',', '.'));
                        element.promedio = totalpromedio.toFixed(5).toString().replace('.', ',');
                        element.error = totalerror.toFixed(5).toString().replace('.', ',');
                        promerror = promerror + totalerror

                        if (cantidad == 1) {
                            minerror = Math.abs(totalerror);
                            maxerror = Math.abs(totalerror);
                        }
                        else {
                            if (Math.abs(totalerror) > Math.abs(maxerror)) {
                                maxerror = Math.abs(totalerror)
                            }
                            if (Math.abs(totalerror) < Math.abs(minerror)) {
                                minerror = Math.abs(totalerror)
                            }
                        }
                    }
                })
            }
            this.cantidadprof = cantidad
            this.errormaximoprof = maxerror.toFixed(5).toString().replace('.', ',')
            this.errorminimoprof = minerror.toFixed(5).toString().replace('.', ',')
            this.errorpromedioprof = (promerror / cantidad).toFixed(5).toString().replace('.', ',')
        },

        calcularerrormotro() {
            var totalpromedio = 0
            var totalerror = 0
            var maxpromedio = 0
            var maxerror = 0
            var minerror = 0
            var cantidad = 0
            var promerror = 0

            if (this.calibmecanicootro.length > 0) {
                this.calibmecanicootro.forEach(element => {
                    if (element.lectpatron != '' && element.lectpatron != 0) {
                        var n = 0
                        var lectura = 0
                        cantidad = cantidad + 1
                        if (element.lectinst1 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst1.toString().replace(',', '.'))
                        }
                        if (element.lectinst2 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst2.toString().replace(',', '.'))
                        }
                        if (element.lectinst3 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst3.toString().replace(',', '.'))
                        }
                        if (element.lectinst4 != '') {
                            n = n + 1
                            lectura = lectura + parseFloat(element.lectinst4.toString().replace(',', '.'))
                        }
                        if (n > 0 && lectura > 0) {
                            totalpromedio = lectura / n
                        }
                        totalerror = totalpromedio - parseFloat(element.lectpatron.toString().replace(',', '.'));
                        element.promedio = totalpromedio.toFixed(5).toString().replace('.', ',');
                        element.error = totalerror.toFixed(5).toString().replace('.', ',');
                        promerror = promerror + totalerror

                        if (cantidad == 1) {
                            minerror = Math.abs(totalerror);
                            maxerror = Math.abs(totalerror);
                        }
                        else {
                            if (Math.abs(totalerror) > Math.abs(maxerror)) {
                                maxerror = Math.abs(totalerror)
                            }
                            if (Math.abs(totalerror) < Math.abs(minerror)) {
                                minerror = Math.abs(totalerror)
                            }
                        }
                    }
                })
            }
            this.cantidadotro = cantidad
            this.errormaximootro = maxerror.toFixed(5).toString().replace('.', ',')
            this.errorminimootro = minerror.toFixed(5).toString().replace('.', ',')
            this.errorpromediootro = (promerror / cantidad).toFixed(5).toString().replace('.', ',')
        },

        selectFiles(files) {
            this.selectedFiles = files;
        },
        vaciarModels() {

            this.fecha = "";
            this.frecuencia = "";
            this.fechaproxcalib = "";
            this.fechaultcalib = "";
            this.calib = [];
            this.calibd = [];
            this.calibint = [];
            this.calibext = [];
            this.calibprof = [];
            this.calibotro = [];
            this.calibanalogico = [
                { lectpatron: '' },
                { lectpatron: '' },
                { lectpatron: '' },
                { lectpatron: '' },
                { lectpatron: '' }
            ];
            this.calibdigital = [
                { lectinst: '', lectpatron: '', unidad: '', errorabs: '', errorrelat: '' },
                { lectinst: '', lectpatron: '', unidad: '', errorabs: '', errorrelat: '' },
                { lectinst: '', lectpatron: '', unidad: '', errorabs: '', errorrelat: '' },
                { lectinst: '', lectpatron: '', unidad: '', errorabs: '', errorrelat: '' },
            ];
            this.calibmecanicoint = [
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            ];
            this.calibmecanicoext = [
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            ];
            this.calibmecanicoprof = [
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            ];
            this.calibmecanicootro = [
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
                { lectpatron: '', unidad: '', lectinst1: '', lectinst2: '', lectinst3: '', lectinst4: '', promedio: '', error: '' },
            ];
            this.patronD = "";
            this.patronA = "";
            this.patronME = "";
            this.patronMI = "";
            this.patronMO = "";
            this.patronMP = "";
            this.valorfe = "";
            this.unidadfe = "";
            this.mantenimiento = [];
            this.flaginst = false;
            this.flagpatronA = false;
            this.flagpatronD = false;
            this.flagpatronMI = false;
            this.flagpatronME = false;
            this.flagpatronMP = false;
            this.flagpatronMO = false;
            this.cantidad = "";
            this.errorabsoluto = "";
            this.errorrelativo = "";
            this.lecturainstrumento = "";
            this.unidadinstrumento = "";
            this.certificadopatron = [];
            this.cantidadint = "";
            this.cantidadext = "";
            this.cantidadprof = "";
            this.cantidadotro = "";
            this.cantidadA = "";
            this.promedioA = "";
            this.maxerror = "";
            this.minerror = "";
            this.promedio = "";
            this.errorabs = "";
            this.errorabsoluto = "";
            this.errorabsolutoA = "";
            this.errorrelativoA = "";
            this.errormax = "";
            this.errormin = "";
            this.errorprom = "";
            this.errorminimoext = "";
            this.errorminimoint = "";
            this.errorminimootro = "";
            this.errorminimoprom = "";
            this.errormaximoint = "";
            this.errormaximoext = "";
            this.errormaximoprof = "";
            this.errormaximootro = "";
            this.observ = "";
            this.selectedFiles = null;

        },

        guardar() {

            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Calibración",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    console.log("patron A" + this.patronA.codgral)
                    console.log("patron D" + this.patronD.codgral)
                    console.log("patron MI" + this.patronMI.codgral)
                    console.log("patron ME" + this.patronME.codgral)
                    console.log("patron MP" + this.patronMP.codgral)
                    console.log("patron MO" + this.patronMO.codgral)

                    // if (this.selectedFiles != null) {
                    //     console.log("ARCHIVO" + this.selectedFiles)
                    //     this.guardararchivo()
                    // }
                    if (this.flagtipo == 'A') {
                        this.calibanalogico.forEach((element) => {
                            if (element.lectpatron != "" && element.lectpatron != null) {
                                this.calib.push({
                                    lectpatron: element.lectpatron,
                                });
                            }
                        });
                        var datos = {

                            codgral: this.codgral,
                            codcalib: this.codcalib,
                            fecha: this.fecha,
                            estado: "X",
                            lecturainstrumento: this.lecturainstrumento,
                            unidad: this.unidadinstrumento,
                            patron: this.patronA.codgral,
                            instrumento: this.instrumento,
                            codinstrumento: this.codinstrumento,
                            cantidad: this.cantidadA,
                            promedio: this.promedioA,
                            errorabs: this.errorabsolutoA,
                            errorrel: this.errorrelativoA,
                            observ: this.observ,
                            detaana: this.calib,

                        };

                        let self = this;
                        console.log(datos)
                        axios
                            .post("/SSGG/GuardarCalAna", datos)
                            .then((response) => {
                                self.$refs.form.resetValidation();

                                self.showAlert({
                                    icon: "success",
                                    title: "Calibración guardada con éxito",
                                    vm: self,
                                });
                                self.vaciarModels();
                                self.$emit("close");
                            })
                            .catch({});
                    }

                    if (this.flagtipo == 'D') {
                        this.calibdigital.forEach((element) => {
                            if (element.lectpatron != "" && element.lectpatron != null) {
                                this.calibd.push({
                                    lectinstr: element.lectinst,
                                    lectpatron: element.lectpatron,
                                    unidad: element.unidad,
                                    errorabs: element.errorabs,
                                    errorrel: element.errorrelat,
                                });
                            }
                        });
                        var datos = {

                            codgral: this.codgral,
                            codcalib: this.codcalib,
                            fecha: this.fecha,
                            estado: "X",
                            valorfe: this.valorfe,
                            unidadfe: this.unidadfe,
                            patron: this.patronD.codgral,
                            instrumento: this.instrumento,
                            codinstrumento: this.codinstrumento,
                            cantidad: this.cantidad,
                            errorabs: this.errorabsoluto,
                            errorrel: this.errorrelativo,
                            observ: this.observ,
                            detadig: this.calibd,

                        };

                        let self = this;
                        console.log(datos)
                        axios
                            .post("/SSGG/GuardarCalDig", datos)
                            .then((response) => {
                                self.$refs.form.resetValidation();

                                self.showAlert({
                                    icon: "success",
                                    title: "Calibración guardada con éxito",
                                    vm: self,
                                });
                                self.vaciarModels();
                                self.$emit("close");
                            })
                            .catch({});
                    }

                    if (this.flagtipo == 'M') {

                        this.calibmecanicoint.forEach((element) => {
                            if (element.lectpatron != "" && element.lectpatron != null) {
                                this.calibint.push({

                                    lectpatron: element.lectpatron,
                                    lectinst1: element.lectinst1,
                                    lectinst2: element.lectinst2,
                                    lectinst3: element.lectinst3,
                                    lectinst4: element.lectinst4,
                                    unidad: element.unidad,
                                    promedio: element.promedio,
                                    error: element.error,
                                    tipo: "I",
                                });
                            }
                        });
                        this.calibmecanicoext.forEach((element) => {
                            if (element.lectpatron != "" && element.lectpatron != null) {
                                this.calibext.push({

                                    lectpatron: element.lectpatron,
                                    lectinst1: element.lectinst1,
                                    lectinst2: element.lectinst2,
                                    lectinst3: element.lectinst3,
                                    lectinst4: element.lectinst4,
                                    unidad: element.unidad,
                                    promedio: element.promedio,
                                    error: element.error,
                                    tipo: "E",
                                });
                            }
                        });
                        this.calibmecanicoprof.forEach((element) => {
                            if (element.lectpatron != "" && element.lectpatron != null) {
                                this.calibprof.push({

                                    lectpatron: element.lectpatron,
                                    lectinst1: element.lectinst1,
                                    lectinst2: element.lectinst2,
                                    lectinst3: element.lectinst3,
                                    lectinst4: element.lectinst4,
                                    unidad: element.unidad,
                                    promedio: element.promedio,
                                    error: element.error,
                                    tipo: "P",
                                });
                            }
                        });
                        this.calibmecanicootro.forEach((element) => {
                            if (element.lectpatron != "" && element.lectpatron != null) {
                                this.calibotro.push({

                                    lectpatron: element.lectpatron,
                                    lectinst1: element.lectinst1,
                                    lectinst2: element.lectinst2,
                                    lectinst3: element.lectinst3,
                                    lectinst4: element.lectinst4,
                                    unidad: element.unidad,
                                    promedio: element.promedio,
                                    error: element.error,
                                    tipo: "O",
                                });
                            }
                        });
                        var datos = []
                        datos.push({
                            codgral: this.codgral,
                            codcalib: this.codcalib,
                            fecha: this.fecha,
                            estado: "X",
                            patron: this.patronMI.codgral,
                            instrumento: this.instrumento,
                            codinstrumento: this.codinstrumento,
                            cantidad: this.cantidadint,
                            errormax: this.errormaximoint,
                            errormin: this.errorminimoint,
                            errorprom: this.errorpromedioint,
                            observ: this.observ,
                            tipo: "I",
                            detamec: this.calibint,
                        });
                        datos.push({
                            codgral: this.codgral,
                            codcalib: this.codcalib,
                            fecha: this.fecha,
                            estado: "X",
                            patron: this.patronME.codgral,
                            instrumento: this.instrumento,
                            codinstrumento: this.codinstrumento,
                            cantidad: this.cantidadext,
                            errormax: this.errormaximoext,
                            errormin: this.errorminimoext,
                            errorprom: this.errorpromedioext,
                            observ: this.observ,
                            tipo: "E",
                            detamec: this.calibext,
                        });
                        datos.push({
                            codgral: this.codgral,
                            codcalib: this.codcalib,
                            fecha: this.fecha,
                            estado: "X",
                            patron: this.patronMP.codgral,
                            instrumento: this.instrumento,
                            codinstrumento: this.codinstrumento,
                            cantidad: this.cantidadprof,
                            errormax: this.errormaximoprof,
                            errormin: this.errorminimoprof,
                            errorprom: this.errorpromedioprof,
                            observ: this.observ,
                            tipo: "P",
                            detamec: this.calibprof,
                        });
                        datos.push({
                            codgral: this.codgral,
                            codcalib: this.codcalib,
                            fecha: this.fecha,
                            estado: "X",
                            patron: this.patronMO.codgral,
                            instrumento: this.instrumento,
                            codinstrumento: this.codinstrumento,
                            cantidad: this.cantidadotro,
                            errormax: this.errormaximootro,
                            errormin: this.errorminimootro,
                            errorprom: this.errorpromediootro,
                            observ: this.observ,
                            tipo: "O",
                            detamec: this.calibotro,
                        });
                        let self = this;
                        console.log(datos)
                        axios
                            .post("/SSGG/GuardarCalMec", datos)
                            .then((response) => {
                                self.$refs.form.resetValidation();

                                self.showAlert({
                                    icon: "success",
                                    title: "Calibración guardada con éxito",
                                    vm: self,
                                });
                                self.vaciarModels();
                                self.$emit("close",);
                            })
                            .catch({});
                    }
                }
            });



        },


        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
